export const formatStockMessage = (stock, size) => {
  if (stock <= 0) return `Tamanho ${size} esgotado.`;
  if (stock === 1) return `Só temos 1 unidade no tamanho ${size}.`;
  return `Só temos ${stock} unidades no tamanho ${size}.`;
};

export const getCartQuantity = (cartItems, productId, size) => {
  const item = cartItems.find(
    (i) => i.id === productId && (i.size || null) === (size || null)
  );
  return item?.quantity || 0;
};

export const canIncreaseQuantity = (stock, currentQty) => currentQty < stock;

export const findCartStockIssues = (cartItems, getStockForSize) =>
  cartItems
    .filter((item) => item.id && item.size)
    .filter((item) => item.quantity > getStockForSize(item.id, item.size))
    .map((item) => ({
      item,
      stock: getStockForSize(item.id, item.size),
    }));
